import WarningIcon from '@mui/icons-material/Warning';
import { Tooltip } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize, fontWeight } from '../../../theme';
import CompareToGlobalButtonStyled, { ComparisonImageStyled } from './styled';

interface CompareToGlobalButtonProps {
    isComparedToGlobal: boolean
    isComparedToPeriod: boolean
    handleToggleCompareToGlobal: (isComparedToGlobal: boolean) => void
}

const CompareToGlobalButton: FC<CompareToGlobalButtonProps> = ({ isComparedToGlobal, isComparedToPeriod, handleToggleCompareToGlobal }) => {
    const { t } = useTranslation('dashboard');

    return (
        <Tooltip
            componentsProps={{
                tooltip: {
                    sx: {
                        bgcolor: colors.grey100,
                        borderRadius: '4px',
                        color: colors.grey000,
                        fontSize: fontSize.sm,
                        fontWeight: fontWeight.semiRegular,
                        maxWidth: 360,
                        padding: '6px 10px',
                        '& .MuiTooltip-arrow': { color: colors.grey100 },
                    },
                },
            }}
            placement="top"
            title={isComparedToPeriod ? (
                <span style={{ display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                    <WarningIcon sx={{ fontSize: '16px', flexShrink: 0 }} />
                    {t('compareToGlobal.replaceTemporalWarning')}
                </span>
            ) : ''}
            arrow
        >
            <CompareToGlobalButtonStyled
                $isActive={isComparedToGlobal}
                aria-pressed={isComparedToGlobal}
                onClick={() => handleToggleCompareToGlobal(!isComparedToGlobal)}
                startIcon={<ComparisonImageStyled />}
                disableRipple
            >
                {t('compareToGlobal.label')}
            </CompareToGlobalButtonStyled>
        </Tooltip>
    );
};

export default CompareToGlobalButton;
